<template>
  <div class="control-footer">
    <div class="control-footer__controls">
      <div v-if="clear" :class="{'control-footer__clear': true, 'control-footer__clear--align-left': selectAll}" @click="$emit('clear')">
        <Icon icon="cross" />
        {{ clear }}
      </div>
      <div v-if="selectAll" class="control-footer__select-all" @click="$emit('selectAll')">{{ selectAll }}</div>
    </div>
    
    <Button v-if="select" role="button" :text="select" @click="$emit('select')" />
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import Icon from '@/components/Icon.vue'
import Button from '@/components/search/SelectButton.vue'

@Component({
  components: {
    Button,
    Icon,
  },
  props: {
    clear: {
      type: String,
      required: false,
      default: () => 'Wyczyść',
    },
    selectAll: {
      type: String,
      required: false,
      default: () => 'Zaznacz wszystkie',
    },
    select: {
      type: String,
      required: false,
      default: () => 'Wybierz',
    },
  },
})
export default class PopupFooter extends Vue {
}
</script>

<style lang="scss">
.control-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  min-height: 94px;
  background-color: #eeeeee;
  color: #535353;
  text-align: center;
  text-transform: uppercase;
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  padding: 0 20px;

  &__controls {
    display: flex;
    width: 100%;
    align-self: center;
    font-size: 12px;
    margin-top: 11px;
  }

  &__clear {
    flex: 1 0 auto;

    .figure {
      font-size: 9px;
      display: inline-block;
      vertical-align: top;
      margin: 4px 2px 0 0;
    }
    &--align-left {
      text-align: left;
    }
  }

  &__select-all {
    text-align: right;
    letter-spacing: -0.2px;
  }

  button {
    align-self: center;
    margin: 7px 0 15px;

    span.figures {
      vertical-align: middle;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search/fields/PopupFooter.vue